export default "__VITE_ASSET__10ed94ba__"